import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export enum EVAverageGraphType {
  TYPE_HIGH_SPEED = 'type_high_speed',
  TYPE_ACCELERATION = 'type_acceleration',
  TYPE_FAST_CHARGE = 'type_fast_charge',
}

interface EVAverageGraphProps {
  title?: string;
  desc?: string;
  children?: React.ReactNode;
}

function EVAverageGraph({title, desc, children}: EVAverageGraphProps) {
  return (
    <div className="records_info">
      <h5 className="records_title">{title}</h5>
      <p
        className="records_info_text"
        style={{whiteSpace: 'pre-wrap'}}
      >
        {desc}
      </p>
      {children}
    </div>
  );
}

interface BarGraphProps {
  filledAreaRatio: number;
  dashedAreaRatio: number;
  graphType: EVAverageGraphType;
  Tags?: Tag[];
}

interface Tag {
  title: string;
  count: number;
  type?: EVAverageGraphType;
}

function BarGraph({filledAreaRatio, dashedAreaRatio, graphType, Tags}: BarGraphProps) {
  const {t} = useInferableTranslation();
  return (
    <>
      <div className="average_graph_area">
        <div className="average_graph_box">
          <div
            className="average_line"
            style={{right: `${dashedAreaRatio * 100}%`}}
          >
            <span className="customer_average">{t('T30429')}</span>
          </div>
          <div className={`average_graph_item ${graphType}`}>
            <div
              className="average_graph_bar"
              style={{width: `${filledAreaRatio * 100}%`}}
            />
          </div>
        </div>
      </div>
      {Tags && Tags.length > 0 && (
        <div className="average_guide">
          {Tags.map(({title, type, count}: Tag) => (
            <span
              className={`tag_info ${type}`}
              key={title}
            >
              {title} <span className="value">{t('T10014_$count', {count})}</span>
            </span>
          ))}
        </div>
      )}
    </>
  );
}

EVAverageGraph.BarGraph = BarGraph;
export default EVAverageGraph;
